import formatMoney from '../../core/formatMoney';
import { selectNewFilter } from './filtering';
import initFilteringOptionsNosto from '../../components/nosto/initFilteringOptions';
import initMobileFilters from './mobileFilters';
import initStickyFilteringMenu from './stickyFilteringMenu';
import initSorting from './sorting';
import initSelectedFilterItems from './selectedFilterItems';
import initFilterMenuADA from './filterMenuADA';
import closeFilterSortSubnav from './closeFilterSortSubnav';

export default class FilteringMenu {
  from_search;

  constructor(from_search = false) {
    this.from_search = from_search;

    if (!this.from_search) {
      initFilteringOptionsNosto();
    }

    initSorting(this.from_search);
    initSelectedFilterItems(this.from_search);
    this.initFilterMenuEvents();
    initFilterMenuADA(this.from_search);
    initMobileFilters(this.from_search);

    if (!this.from_search) {
      initStickyFilteringMenu();
    }
  }

  initFilterMenuEvents = () => {
    const prefix = (this.from_search) ? 'overlay-search-' : '';

    // Click the desktop "filters" button
    $(document).on('click', `[data-${prefix}show-desktop-filter-nav]`, (e) => {
      const $item = $(e.currentTarget);
      this.selectFilteringSubnav($item);
    });

    // Click the "close" button
    $(document).on('click', `[data-filter-close]`, (e) => {
      e.stopPropagation();
      const $item = $(e.currentTarget);
      closeFilterSortSubnav($item.closest('.filter-filtering').find('.filter-button-desktop'));
      return;
    });

    // Click the "close" button
    $(document).on('click', `[data-sorting-close]`, (e) => {
      e.stopPropagation();
      const $item = $(e.currentTarget);
      closeFilterSortSubnav($item.closest('.filter-sorting').find('.sort-button-desktop'));
      return;
    });

    // Filter option
    $(document).on('click', `[data-${prefix}filter-options] [data-clickable-option]`, async (e) => {
      const $item = $(e.currentTarget);
      const target = $item[0]; // for vanilla js version
      const option_type = target.closest(`[data-${prefix}filter-options]`);
      let option_value = $item.data('option-value');
      const option_short_value = $item.data('option-short-value');

      // Check / uncheck the related input checkbox for ADA
      const adaInput = target.querySelector('[data-option-ada]');
      if (adaInput) adaInput.checked = target.classList.contains('active');

      // Sync desktop/mobile selections
      const all_same_items = document.querySelectorAll(
        `[data-${prefix}filter-options-type="${option_type.getAttribute(`data-${prefix}filter-options-type`)}"] [data-option-value="${option_value}"]`
      );
      all_same_items.forEach(all_same_item => {
        all_same_item.classList.toggle('active');
        if (all_same_item.parentElement) {
          all_same_item.parentElement.classList.toggle('active');
        }
      });

      // Select/unselect all similar options
      if (target.getAttribute('data-master-option') === 'true') {
        const all_similar_options = document.querySelectorAll(
          `[data-${prefix}filter-options-type="${option_type.getAttribute(`data-${prefix}filter-options-type`)}"] [data-option-short-value="${option_short_value}"]`
        );
        all_similar_options.forEach(all_similar_option => {
          if (all_similar_option.getAttribute('data-master-option') !== 'true') {
            all_similar_option.classList.toggle('active');
            if (all_similar_option.parentElement) {
              all_similar_option.parentElement.classList.toggle('active');
            }
          }
        });
      }

      // Add/remove the option to the selected filters list
      if (target.classList.contains('active')) {
        // Add the option to the selected filters list
        if (target.classList.contains('newfilter-checkbox')) {
          if (option_value.includes('vt::')) {
            option_value = option_value.split('::').pop();
          }

          // if (option_value.includes('USD:')) {
          //   option_value = option_value.replace(new RegExp('USD:', 'g'), '$');
          // }

          if (option_type.getAttribute(`data-${prefix}filter-options-type`) === 'price') {
            // option_value = `${currency_symbol}${option_value.replace(':', `-${currency_symbol}`)}`;
            const price_range_parts = option_value.split('-');
            option_value = `${formatMoney(Math.ceil(Number(price_range_parts[0]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}-${formatMoney(Math.ceil(Number(price_range_parts[1]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}`;
          }

          // Make sure to also update the code in filterState.js if editing the html below
          const filterOptionParent = target.closest('.filter-option');
          const selected_filter_item_html = `
            <div class="selected-filters__item"
              data-${prefix}selected-filters-item
              data-${prefix}selected-filters-short-value="${option_short_value}"
              data-${prefix}selected-filters-type="${filterOptionParent.getAttribute(`data-${prefix}filter-options-type`)}"
              data-selected-filters-value="${target.getAttribute('data-option-value')}"
              role="button"
              tabindex="0">
              ${option_value}
            </div>`;

          // $(`[data-${prefix}selected-filters-list]`).append(selected_filter_item_html);
          const clearAllEls = document.querySelectorAll(`[data-${prefix}selected-filters-list] [data-${prefix}clear-all-filters]`);
          clearAllEls.forEach(clearAllEl => {
            clearAllEl.insertAdjacentHTML('beforebegin', selected_filter_item_html);
          });
        }
      } else {
        // Remove the option from the selected filters list
        document.querySelectorAll(
          `[data-${prefix}selected-filters-list] [data-${prefix}selected-filters-item][data-selected-filters-value="${target.getAttribute('data-option-value')}"]`
        ).forEach(el => el.remove());
      }

      // Hide the list if no filters selected
      const filters_lists = document.querySelectorAll(`[data-${prefix}selected-filters-list]`);
      filters_lists.forEach(filters_list => {
        const filters_items = filters_list?.querySelectorAll(`[data-${prefix}selected-filters-item]`);
        const filters_parent = filters_list?.parentElement;
        
        if (filters_parent) {
          filters_parent.classList.toggle('active', filters_items?.length > 0);
        }
      });
  
      // console.log('selected desktop option', $item.data('option-value'));
      await selectNewFilter();
    });
  };

  // Open/Close the filter subnav
  selectFilteringSubnav = ($subnav) => {
    const from_search = document.body.classList.contains('has-overlay-search');
    const prefix = (from_search) ? 'overlay-search-' : '';

    closeFilterSortSubnav($subnav.closest('.filters-panel-v2__buttons').find('.sort-button-desktop'));

    $subnav.parent().toggleClass('active');
    const is_active = $subnav.parent().hasClass('active');
    const $filter_by_container = $subnav.parent().find(`[data-${prefix}filter-by]`);
    
    if (is_active) {
      // Assign the subnav height based on max column height
      let max_height = 0;
      const containers = $filter_by_container[0].querySelectorAll(`[data-${prefix}filter-options-container]`);
      containers.forEach(item => {
        const height = item.offsetHeight;
        max_height = height > max_height ? height : max_height;
      });

      // Add header + top/bottom spacing + space for the buttons
      max_height += 80 + 60;
      
      $filter_by_container.height(max_height);

      // We don't want to have the filters going over the search results overlay
      if (from_search) {
        document.querySelectorAll('[data-overlay-search-results]').forEach(el => {
          el.style.minHeight = `${max_height}px`;
        });
      }

      // Hide the grid options
      if ($subnav.closest('.filters-panel-v2__actions').find('[data-change-grid-parent]').length) {
        $subnav.closest('.filters-panel-v2__actions').find('[data-change-grid-parent]').addClass('visually-hidden');
      }

      // Place the filter buttons at the bottom
      $('[data-filter-buttons]').css('top', `${max_height}px`);

      // [ADA] related
      $subnav.attr('aria-expanded', true);
      const $filter_by = $filter_by_container;
      $filter_by.attr('tabindex', '1');

      return;
    }

    closeFilterSortSubnav($subnav);
  };
}
